<template>
  <vs-card>
    <vs-table max-items="10" pagination :data="$store.getters['unicorn/dataTable']">
      <template slot="header">
        <h3>Stock</h3>
      </template>
      <template slot="thead">
        <vs-th> Name </vs-th>
        <vs-th> Mac Address </vs-th>
        <vs-th> Details </vs-th>
        <vs-th> Quantity </vs-th>
        <vs-th> Time </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].name">
            {{ data[indextr].name }}
          </vs-td>

          <vs-td :data="data[indextr].mac">
            {{ data[indextr].mac }}
          </vs-td>

          <vs-td :data="data[indextr].detail">
            {{ data[indextr].detail }}
          </vs-td>

          <vs-td :data="data[indextr].quantity">
            {{ data[indextr].quantity }}
          </vs-td>

          <vs-td :data="data[indextr].showTime">
            {{ data[indextr].showTime }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vs-card>
</template>

<script>
export default {
  props: {
  },
};
</script>

<style>
</style>